const PerfisHome = () => import(/* webpackChunkName: "group-users" */ '../_views/PerfisHome')
const CadastroPerfil = () => import(/* webpackChunkName: "group-users" */ '../_views/CadastroPerfil')
const AtualizarPerfil = () => import(/* webpackChunkName: "group-users" */ '../_views/AtualizarPerfil')

import { permissoesPerfil } from '../../../utils/permissoesUsuarios'

export default [
  {
    path: 'roles',
    component: PerfisHome,
    meta: { requiresAuth: true, permissions: [...permissoesPerfil] },
    name: 'Perfil',
  },
  {
    path: 'roles/criar',
    component: CadastroPerfil,
    meta: {
      requiresAuth: true,
      permissions: [process.env.VUE_APP_ADMINISTRADOR, process.env.VUE_APP_USUARIOS_CADASTRO_PERFIL_TOTAL],
    },
    name: 'roles/criar',
  },
  {
    path: 'roles/atualizar/:id',
    component: AtualizarPerfil,
    meta: { requiresAuth: true, permissions: [...permissoesPerfil] },
    name: 'roles/atualizar',
    props: true,
  },
]
